import React, { useState } from "react";
import Modal from "react-modal";
import "../../../styles/lead-mangement/lead-details.css";
import {
  convertStraight,
  convertThenFormat,
  formatDateTime,
} from "../../common-data/Converts";
import ModalHeadAndClose from "../../payouts-wtf/common/ModalHeadAndClose";

const LeadDetails = ({ rowData }) => {
  const iniClickValues = {
    isModOpen: false,
    rowData: "",
    cardName: "",
  };
  const [clickValues, setClickValues] = useState(iniClickValues);

  const getIntentColor = (intent) => {
    return intent?.toLowerCase() === "interested" ? "#379C00" : "#D7263D";
  };

  const isLeadConverted = rowData?.lead_status === "converted";
  const isRawLead = rowData?.is_raw_lead || rowData?.lead_from === "raw_lead";
  const isReferredBy =
    rowData?.lead_from === "website_referral" ||
    rowData?.source_name === "referral";
  const isBTLLead =
    rowData?.lead_from === "btl_marketting" ||
    rowData?.source_name === "btl_marketting";

  function onCloseModal() {
    setClickValues(iniClickValues);
  }

  return (
    <>
      <Modal
        isOpen={clickValues.isModOpen}
        onRequestClose={onCloseModal}
        contentLabel="Edit Modal"
        ariaHideApp={false}
      >
        <div
          className={`createNewCTOModalContainer ${
            clickValues.cardName === "view_details" ? "" : "add-new-lead-form"
          } ${
            clickValues.cardName === "edit" ||
            clickValues.cardName === "re-assign" ||
            clickValues.cardName === "wap_image"
              ? "modal-container-abs"
              : ""
          } ${
            clickValues.cardName === "follow-up" ? "followupSystemModal" : ""
          }`}
        >
          <ModalHeadAndClose
            title={`${
              clickValues.cardName === "wap_image"
                ? clickValues.rowData?.name
                : clickValues.cardName?.replace(/_/, " ")
            }`}
            onClose={onCloseModal}
          />

          {clickValues.cardName === "wap_image" ? (
            <div className="discussionModalMessage mt30">
              <img src={clickValues.rowData?.wap_image} alt="profile" />
            </div>
          ) : null}
        </div>
      </Modal>

      <div className="user-profile-container lead-details-container">
        <div className="flexCol">
          <div className="user-profile-img">
            <p className="info-name" style={{ flexDirection: "column" }}>
              <b>{rowData?.name || "NA"}</b>
              <br />
              <small className="profile-name-attached-icon green">
                Lead ID: {rowData?.lead_id || "-"}
              </small>
            </p>

            <p className="info-name" style={{ textDecoration: "underline" }}>
              {rowData?.mobile || ""}
            </p>

            <p
              className="info-name"
              style={{
                textTransform: `${
                  rowData?.email ? "lowercase" : "capitialize"
                }`,
                textDecoration: "underline",
              }}
            >
              {rowData?.email || ""}
            </p>

            <p className="info-name">{rowData?.gym_name || "NA"}</p>

            <p className="info-name">
              Added on{" "}
              {rowData?.date_added ? formatDateTime(rowData.date_added) : "-"}
            </p>

            <p
              className={`info-name info-status ${
                rowData?.lead_status === "converted"
                  ? "active"
                  : rowData?.lead_status === "pending"
                  ? "pending"
                  : "inactive"
              }`}
            >
              Lead{" "}
              {rowData?.lead_status === "pending"
                ? "Upcoming Followup"
                : rowData?.lead_status?.replace(/_/g, " ") || "-"}
            </p>
          </div>

          <div className="user-profile-details">
            <div className="user-details">
              <div className="user-details-head">
                <p className="head-name">Follow-up Stage</p>
              </div>
              <div className="user-details-info">
                <p
                  className="info-name"
                  style={{
                    background: "#5A56E4",
                    color: "#fff",
                    padding: "5px 10px",
                    borderRadius: "4px",
                    marginTop: "2px",
                    letterSpacing: "1px",
                  }}
                >
                  {rowData?.follow_up_number || "-"}
                </p>
              </div>
            </div>

            <div className="user-details">
              <div className="user-details-head">
                <p className="head-name">Follow-up Count</p>
              </div>
              <div className="user-details-info">
                <p
                  className="info-name"
                  style={{
                    background: "#157EF9",
                    color: "#fff",
                    padding: "5px 10px",
                    borderRadius: "4px",
                    marginTop: "2px",
                    letterSpacing: "1px",
                  }}
                >
                  {rowData?.followup_days_count || "-"}
                </p>
              </div>
            </div>

            <div className="user-details">
              <div className="user-details-head">
                <p className="head-name">Customer Intent</p>
              </div>
              <div className="user-details-info">
                <p
                  className="info-name"
                  style={{
                    background: getIntentColor(rowData?.cutomer_intent),
                    color: "#fff",
                    padding: "10px",
                    borderRadius: "16px",
                  }}
                >
                  {rowData?.cutomer_intent?.replace(/_/g, " ") || "NA"}
                </p>
              </div>
            </div>

            <div className="user-details">
              <div className="user-details-head">
                <p className="head-name">Last follow-up status</p>
              </div>
              <div className="user-details-info">
                <p className="info-name">
                  {rowData?.current_followup_status?.replace(/_/g, " ") || "NA"}
                </p>
              </div>
            </div>

            <div className="user-details">
              <div className="user-details-head">
                <p className="head-name">Next Follow-up Date</p>
              </div>
              <div className="user-details-info">
                <p className="info-name">
                  {rowData?.next_followup_date
                    ? formatDateTime(rowData.next_followup_date)
                    : "-"}
                </p>
              </div>
            </div>
          </div>
        </div>

        <div className="user-profile-details">
          <div className="user-details">
            <div className="user-details-head">
              <p className="head-name">Added By</p>
            </div>
            <div className="user-details-info">
              <p className="info-name">{rowData?.added_by_name || "NA"}</p>
            </div>
          </div>

          <div className="user-details">
            <div className="user-details-head">
              <p className="head-name">Assigned To</p>
            </div>
            <div className="user-details-info">
              <p className="info-name">{rowData?.assigned_to_name || "NA"}</p>
            </div>
          </div>

          <div className="user-details">
            <div className="user-details-head">
              <p className="head-name">Expected Conversion Plan Type</p>
            </div>
            <div className="user-details-info">
              <p className="info-name">
                {rowData?.plan_type?.replace(/_/g, " ") || "NA"}
              </p>
            </div>
          </div>

          <div className="user-details">
            <div className="user-details-head">
              <p className="head-name">Expected Lead Conversion Amount</p>
            </div>
            <div className="user-details-info">
              <p className="info-name">
                ₹{convertThenFormat(rowData?.lead_value || 0)}
              </p>
            </div>
          </div>

          {isLeadConverted && (
            <div className="user-details">
              <div className="user-details-head">
                <p className="head-name">Lead Conversion Amount</p>
              </div>
              <div className="user-details-info">
                <p className="info-name">
                  ₹{convertThenFormat(rowData?.converted_value || 0)}
                </p>
              </div>
            </div>
          )}

          <div className="user-details">
            <div className="user-details-head">
              <p className="head-name">Expected Closure Date</p>
            </div>
            <div className="user-details-info">
              <p className="info-name">
                {rowData?.expected_closure_date
                  ? convertStraight(rowData.expected_closure_date)
                  : "NA"}
              </p>
            </div>
          </div>

          {isLeadConverted && (
            <div className="user-details">
              <div className="user-details-head">
                <p className="head-name">Conversion Date</p>
              </div>
              <div className="user-details-info">
                <p className="info-name">
                  {rowData?.conversion_date
                    ? convertStraight(rowData.conversion_date)
                    : "NA"}{" "}
                  {rowData?.conversion_days && (
                    <small>({rowData?.conversion_days || ""})</small>
                  )}
                </p>
              </div>
            </div>
          )}

          <div className="user-details">
            <div className="user-details-head">
              <p className="head-name">Source Name</p>
            </div>
            <div className="user-details-info">
              <p className="info-name">
                {rowData?.source_name?.replace(/_/g, " ") || "NA"}
              </p>
            </div>
          </div>

          <div className="user-details">
            <div className="user-details-head">
              <p className="head-name">UTM Source</p>
            </div>
            <div className="user-details-info">
              <p className="info-name">{rowData?.utm_source || "Organic"}</p>
            </div>
          </div>

          <div className="user-details">
            <div className="user-details-head">
              <p className="head-name">Lead From</p>
            </div>
            <div className="user-details-info">
              <p className="info-name">
                {rowData?.lead_from?.replace(/_/g, " ") || "NA"}
              </p>
            </div>
          </div>

          {isReferredBy && (
            <div className="user-details">
              <div className="user-details-head">
                <p className="head-name">Referred By</p>
              </div>
              <div className="user-details-info">
                <p className="info-name">{rowData?.referred_by || "NA"}</p>
              </div>
            </div>
          )}

          {isRawLead && (
            <div className="user-details">
              <div className="user-details-head">
                <p className="head-name">Raw Lead Add To LMS Date</p>
              </div>
              <div className="user-details-info">
                <p className="info-name">
                  {formatDateTime(rowData.rawlead_added_date)}
                </p>
              </div>
            </div>
          )}

          {isBTLLead && (
            <>
              <div className="user-details">
                <div className="user-details-head">
                  <p className="head-name">BTL Vendor Name</p>
                </div>
                <div className="user-details-info">
                  <p className="info-name">
                    {rowData?.btl_vendor_name || "NA"}
                  </p>
                </div>
              </div>

              <div className="user-details">
                <div className="user-details-head">
                  <p className="head-name">BTL Vendor Mobile</p>
                </div>
                <div className="user-details-info">
                  <p className="info-name">
                    {rowData?.btl_vendor_mobile || "NA"}
                  </p>
                </div>
              </div>

              <div className="user-details">
                <div className="user-details-head">
                  <p className="head-name">BTL Vendor Email</p>
                </div>
                <div className="user-details-info">
                  <p className="info-name">
                    {rowData?.btl_vendor_email || "NA"}
                  </p>
                </div>
              </div>
            </>
          )}

          <div className="user-details">
            <div className="user-details-head">
              <p className="head-name">WhatsApp Image</p>
            </div>
            <div className="user-details-info">
              <p className="info-name">
                {rowData?.wap_image ? (
                  <img
                    src={rowData.wap_image}
                    alt="WhatsApp"
                    style={{
                      maxWidth: "200px",
                      cursor: rowData?.wap_image ? "pointer" : "not-allowed",
                      opacity: rowData?.wap_image ? 1 : 0.5,
                    }}
                    onClick={
                      rowData?.wap_image
                        ? () =>
                            setClickValues((prevs) => ({
                              ...prevs,
                              isModOpen: true,
                              rowData: rowData,
                              cardName: "wap_image",
                            }))
                        : null
                    }
                    disabled={!rowData?.wap_image}
                  />
                ) : (
                  "NA"
                )}
              </p>
            </div>
          </div>

          <div className="user-details">
            <div className="user-details-head">
              <p className="head-name">Total Outgoing Calls</p>
            </div>
            <div className="user-details-info">
              <p className="info-name">
                {rowData?.total_outgoing_call || "NA"}
              </p>
            </div>
          </div>

          <div className="user-details">
            <div className="user-details-head">
              <p className="head-name">Connected Calls</p>
            </div>
            <div className="user-details-info">
              <p className="info-name">
                {rowData?.total_outgoing_connected_call || "NA"}
              </p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default LeadDetails;
